import CategoryContent from '../components/CategoryContent';
import { categoryPageData, symbolsByCategory } from '../data/pageData';
import { PAGE_TYPE } from '../data/pageIds';
import CategoryPage from '../components/CategoryPage';

const allData = [categoryPageData];

export function getStaticPaths() {
  const paths = [];

  for (const dataEntry of allData) {
    for (const id in dataEntry) {
      paths.push({ params: { id } });
    }
  }

  return {
    paths,
    fallback: false,
  };
}

function getProps(id: string) {
  for (const dataEntry of allData) {
    if (dataEntry[id]) {
      return dataEntry[id];
    }
  }
}

export function getStaticProps({ params: { id } }) {
  return { props: { id, ...getProps(id) } };
}

export default function Page(props) {
  const { id, type, imgs } = props;

  switch (type) {
    case PAGE_TYPE.category: {
      const symbols = [symbolsByCategory[id]];
      return (
        <CategoryPage symbols={symbols} category={id}>
          <CategoryContent category={id} imgs={imgs} />
        </CategoryPage>
      );
    }
  }
}
